import React                 from 'react';
import {render}              from 'react-dom';
import NavbarFavorites       from '../components/NavbarSpecialElements/NavbarFavorites';
import NavbarMessages        from '../components/NavbarSpecialElements/NavbarMessages';
import NavbarNotifications   from '../components/NavbarSpecialElements/NavbarNotifications';
import NavbarGuestMenu       from '../components/NavbarSpecialElements/NavbarGuestMenu';
import {run as NavBarRunner} from './NavBarHelper';

function run(
	favoritesContainerId,
	favoriteCollectionUrl,
	isAfterLogin,
	messagesContainerId,
	unreadMessagesCount,
	messages,
	messengerUrl,
	notificationsContainerId,
	guestMenuContainerId,
	guestName,
	guestBalanceFormatted,
	guestUrlPreviewPicture,
	myVisitXUrl,
	myVisitXGuestProfileUrl,
	myVisitXGuestFavoriteActorsUrl,
	isSelected,
	vipClubUrl
) {
	let container;

	// favorites
	container = document.getElementById(favoritesContainerId);
	if (container) {
		render(
			<NavbarFavorites
				collectionUrl={favoriteCollectionUrl}
				isAfterLogin={isAfterLogin}
			/>,
			container
		);
	}

	// messages
	container = document.getElementById(messagesContainerId);
	if (container) {
		render(
			<NavbarMessages
				initialMessages={messages}
				initialUnreadMessagesCount={unreadMessagesCount}
				messengerUrl={messengerUrl}
			/>,
			container
		);
	}

	// notifications
	container = document.getElementById(notificationsContainerId);
	if (container) {
		render(
			<NavbarNotifications />,
			container
		);
	}

	// guest menu
	container = document.getElementById(guestMenuContainerId);
	if (container) {
		render(
			<NavbarGuestMenu
				guestName={guestName}
				guestBalanceFormatted={guestBalanceFormatted}
				guestUrlPreviewPicture={guestUrlPreviewPicture}
				myVisitXUrl={myVisitXUrl}
				myVisitXGuestProfileUrl={myVisitXGuestProfileUrl}
				myVisitXGuestFavoriteActorsUrl={myVisitXGuestFavoriteActorsUrl}
				vipClubUrl={vipClubUrl}
				isSelected={isSelected}
			/>,
			container
		);
	}

	// run navbar handler
	NavBarRunner();
}

export {run};
